/* ==========================================================================
   Custom Banner Slideshow — main.js (assets/custom-banner.js)
   Initializes every .custom-banner-section on the page independently.
   Re-initializes on Shopify theme-editor section load events.
   ========================================================================== */

(function () {
  'use strict';

  function initBanner(wrap) {
    if (!wrap || wrap.dataset.cbInitialized === 'true') return;
    wrap.dataset.cbInitialized = 'true';

    var track   = wrap.querySelector('.cb-slider');
    var dots    = wrap.querySelectorAll('.cb-dot');
    var prev    = wrap.querySelector('.cb-arrow--prev');
    var next    = wrap.querySelector('.cb-arrow--next');
    var slides  = wrap.querySelectorAll('.cb-slide');
    var total   = slides.length;
    var current = 0;
    var autoplay = wrap.dataset.autoplay === 'true';
    var speed   = parseInt(wrap.dataset.speed, 10) || 5000;
    var timer   = null;

    if (!track || total === 0) return;

    function goTo(idx) {
      current = (idx + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });

      // Video slide: autoplay Shopify native video when it becomes active
      slides.forEach(function (slide, i) {
        var vid = slide.querySelector('video');
        if (!vid) return;
        if (i === current) {
          vid.play().catch(function () {});
        } else {
          vid.pause();
          vid.currentTime = 0;
        }
      });
    }

    function startTimer() {
      if (!autoplay || total <= 1) return;
      clearInterval(timer);
      timer = setInterval(function () {
        goTo(current + 1);
      }, speed);
    }
    function stopTimer() {
      clearInterval(timer);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        goTo(current - 1);
        startTimer();
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        goTo(current + 1);
        startTimer();
      });
    }
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(this.dataset.index, 10));
        startTimer();
      });
    });

    wrap.addEventListener('mouseenter', stopTimer);
    wrap.addEventListener('mouseleave', startTimer);

    var touchX = 0;
    wrap.addEventListener(
      'touchstart',
      function (e) {
        touchX = e.changedTouches[0].screenX;
      },
      { passive: true }
    );
    wrap.addEventListener(
      'touchend',
      function (e) {
        var diff = touchX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          goTo(diff > 0 ? current + 1 : current - 1);
          startTimer();
        }
      },
      { passive: true }
    );

    // Store handles so theme-editor events (below) can pause/resume this instance
    wrap._cbStopTimer = stopTimer;
    wrap._cbStartTimer = startTimer;

    goTo(0);
    startTimer();
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.custom-banner-section').forEach(initBanner);
  }

  // First load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Shopify theme-editor support: re-init when a banner section is added/reloaded
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Pause autoplay while editing in theme editor (avoids fighting with editor UI)
  document.addEventListener('shopify:section:select', function (event) {
    var wrap = event.target.querySelector
      ? event.target.querySelector('.custom-banner-section')
      : null;
    if (wrap && wrap._cbStopTimer) wrap._cbStopTimer();
  });
  document.addEventListener('shopify:section:deselect', function (event) {
    var wrap = event.target.querySelector
      ? event.target.querySelector('.custom-banner-section')
      : null;
    if (wrap && wrap._cbStartTimer) wrap._cbStartTimer();
  });
})();
